var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m3.31 8.506 1.073 4.827H2.497a.208.208 0 0 1-.204-.253L3.31 8.506Zm2.52 4.827a.208.208 0 0 1-.203-.163L4.145 6.504a.208.208 0 0 1 .204-.254h11.255c.098 0 .183.068.204.163l1.481 6.667a.208.208 0 0 1-.203.253H5.83ZM3.31 5h12.963c.293 0 .546.203.61.49l1.852 8.333a.625.625 0 0 1-.61.76H1.458a.625.625 0 0 1-.61-.76L2.7 5.49A.625.625 0 0 1 3.31 5ZM6.389 9.33c0-.345.28-.625.625-.625h7.407a.625.625 0 1 1 0 1.25H7.014a.625.625 0 0 1-.625-.625Z",
  clipRule: "evenodd"
})));
SvgTent.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgTent);
export default ForwardRef;